/**
 * @file GDotLookupButtonField.jsx
 * @description 
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * https://muhimasri.com/blogs/customizing-disabled-button-colors-with-mui/
 * 
 * @author don michael
 * @since Oct 03, 2025 20:43
 */
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import FormHelperText from '@mui/material/FormHelperText';

import YoutubeSearchedForTwoToneIcon from '@mui/icons-material/YoutubeSearchedForTwoTone';

import { objectExists } from 'src/@common/utilities';

function GDotLookupButtonField(props) {
    const {
        sxStyle,
        isDisabled = false,
        helpMsg = '',
        handleGDotLookup,
    } = props;

    let containerSxStyle = {
        mt: '45px',
        ml: '10px',
        "&.Mui-disabled": {
            background: "#eaeaea",
            color: "#c0c0c0"
        },
    }

    if (objectExists(sxStyle)) {
        containerSxStyle = sxStyle;
    }

    return (
        <>
            <Button
                size="small"
                sx={containerSxStyle}
                disabled={isDisabled}
                variant="outlined"
                color="primary"
                startIcon={<YoutubeSearchedForTwoToneIcon />}
                onClick={(ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    handleGDotLookup();
                }}
            >
                G-Dot Lookup
            </Button>

            <FormHelperText id="gDotLookupHelpMsg" sx={{
                ml: '14px',
                mt: '2px'
            }}>
                {helpMsg}
            </FormHelperText>
        </>

    );
}

GDotLookupButtonField.propTypes = {
    sxStyle: PropTypes.object,
    isDisabled: PropTypes.bool.isRequired,
    helpMsg: PropTypes.string.isRequired,
    handleGDotLookup: PropTypes.func.isRequired,
};

export default GDotLookupButtonField;
